export const initialListWithLoadingAndErrorState = {
    data: [],
    loading: false,
    error: false
}

export const initialListWithLoadingAndErrorStateAndTotalElements = {
    data: {
        totalItems: 0,
        data: []
    },
    loading: false,
    error: false
}

export const initialSimsAssociatedToPlanFilterData = {
    data: {
        piano: []
    },
    loading: false
}

export const initialContractDetailsState = {
    data: {
        id: "",
        idCaption: "",
        changeInSelf: true,
        changeInSelfCaption: "",
        idTrattativa: "",
        descrizione: "",
        dataSottoscrizione: null,
        dataSottoscrizioneDisplayValue: null
    },
    loading: false
}

export const initialContractTablesDataState = {
    data: {
        planVoiceDataList: [],
        planDataList: [],
        optionsList: [],
        extraSharesActiveList: [],
        extraSharesNotActiveList: [],
    },
    loading: false
}

export const initialDeviceDetailsConsegneState = {
    data: {
        deviceConsegneList: [],
        qtaConsegnata: ''
    },
    loading: false
}

export const initialDeviceDetailsConsegnatiState = {
    data: {
        deviceConsegnatiList: [],
    },
    loading: false
}

export const initialCurrentOfferState = {
    data: {
        planName: "",
        planDescription: "",
        commercialLabel: "",
        offertaTopItemList: [],
        offertaZoneItemList: [],
        opzioniGettoniDtoList: []
    },
    loading: false
}

export const initialServiceListsState = {
    data: {
        descrizioneServizioApn: "",
        canoneUnitarioApn: "",
        descrizioneServizioAssistenzaPremium: "",
        canoneUnitarioAssistenzaPremium: "",
        showAssistenzaPremium: false,
        showApnPrivato: false
    },
    loading: false
}

export const initialApnTablesState = {
    data: {
        apnDedicato: [{
            nome: "",
            costoAttivazione: "",
            costoUnitario: "",
            stato: "",
            detailsButton: false
        }],
        apnCondiviso: [{
            nome: "",
            costoAttivazione: "",
            costoUnitario: "",
            stato: "",
            detailsButton: false
        }]
    },
    loading: false
}

export const initialServiceDetailsState = {
    data: [],
    loading: false
}

export const initialFilterSimCollaboratorsState = {
    data: [],
    loading: false
}

export const initialApnSimTable = {
    data: {
        sims: [],
        totalElements: 0
    },
    loading: false
}

export const initialApnSimsFilterData = {
    data: {
        tags: [],
        apnTypes: [],
        apnNames: []
    },
    loading: false
}

